import ReactApexChart from 'react-apexcharts';
import ApexCharts from 'apexcharts'
import React from 'react';
import { isMobileDevice } from '../commons/utils';
import { ExPaper } from '../components/Paper';
import moment from 'moment';

interface IState {
    options?: any;
    series?: any;
    height?: any;
    selection?: string
}

class AreaChart extends React.Component<any, IState> {
    constructor(props: any) {
        super(props);

        this.state = {
            series: [],
            options: {
                chart: {
                    id: 'area-datetime',
                    toolbar: { show: !isMobileDevice() },
                    zoom: { show: false },
                    background: 'transparent',
                    defaultLocale: 'pt-br',
                    locales: [{
                        "name": "pt-br",
                        "options": {
                            "months": [
                                "Janeiro",
                                "Fevereiro",
                                "Março",
                                "Abril",
                                "Maio",
                                "Junho",
                                "Julho",
                                "Agosto",
                                "Setembro",
                                "Outubro",
                                "Novembro",
                                "Dezembro"
                            ],
                            "shortMonths": [
                                "Jan",
                                "Fev",
                                "Mar",
                                "Abr",
                                "Mai",
                                "Jun",
                                "Jul",
                                "Ago",
                                "Set",
                                "Out",
                                "Nov",
                                "Dez"
                            ],
                            "days": [
                                "Domingo",
                                "Segunda",
                                "Terça",
                                "Quarta",
                                "Quinta",
                                "Sexta",
                                "Sábado"
                            ],
                            "shortDays": ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
                            "toolbar": {
                                "exportToSVG": "Baixar SVG",
                                "exportToPNG": "Baixar PNG",
                                "exportToCSV": "Baixar CSV",
                                "menu": "Menu",
                                "selection": "Selecionar",
                                "selectionZoom": "Selecionar Zoom",
                                "zoomIn": "Aumentar",
                                "zoomOut": "Diminuir",
                                "pan": "Navegação",
                                "reset": "Reiniciar Zoom"
                            }
                        }
                    }]
                },
                plotOptions: {
                    bar: {
                        endingShape: 'rounded',
                        borderRadius: 4,
                        borderRadiusApplication: 'end',
                        dataLabels: { position: 'top' }
                    }
                },
                xaxis: {
                    type: 'datetime',
                    labels: {
                        style: { colors: '#fff' },
                        datetimeFormatter: {
                            year: 'yyyy',
                            month: "MM/yyyy",
                            day: 'dd MMM',
                            hour: 'HH:mm',
                            minute: 'HH:mm:ss',
                            second: 'HH:mm:ss',
                        }
                    }
                },
                yaxis: {
                    labes: {
                        style: { colors: '#fff' },
                        //format: 'DD/MM'
                        // formatter: (val: any) => {
                        //     if (val >= 1000) { return `${(val / 1000).toFixed(1)} mil` }
                        //     console.log('vaaa', val)
                        //     return val.toFixed(2);
                        // },                        
                    },
                    tickAmount: 4,
                    min: 0
                },
                fill: {
                    type: 'gradient',
                    gradient: {
                        shadeIntensity: 1,
                        opacityFrom: 0.1,
                        opacityTo: 0.7,
                        stops: [0, 100]
                    }
                },
                tooltip: {
                    theme: 'dark', x: {
                        format: 'dd MMM yyyy'
                    }
                },
                theme: { mode: 'dark' },
                stroke: { curve: 'smooth' },
                title: {
                    align: 'center',
                    style: {
                        color: '#fff',
                        fontWeight: 500,
                        fontFamily: "Montserrat, Segoe UI",
                    }
                }
            },
            selection: 'all'
        }
    }

    setSeries = (series: any) => {
        this.setState({
            series
        });
    }

    setOptions = (labels: any[] | [], maxValue: any | null, title: any, percent?: boolean, colors?: any, legend?: boolean, fontSize?: any, type?: undefined | 'datetime') => {
        this.setState({
            options: {
                ...this.state.options,
                colors: colors ? colors : ['var(--primary-color)'],
                xaxis: {
                    ...this.state.options.xaxis,
                    // labels: {
                    //     formatter: (val: any) => {
                    //         if (val === 0) return '';
                    //         return type ? moment(val).format('DD/MM/YYYY') : val;
                    //     },
                    // },
                    categories: labels,
                    type,
                },
                yaxis: {
                    ...this.state.options.yaxis,
                    max: maxValue ? maxValue : null,
                },
                dataLabels: {
                    enabled: labels.length <= 30,
                    style: { fontSize: isMobileDevice() ? '12px' : (fontSize ? fontSize : '20px') },
                },
                title: {
                    ...this.state.options.title,
                    text: title
                },
                legend: {
                    show: legend
                },
            }
        });
    }

    updateData(timeline: string) {
        this.setState({
            selection: timeline
        })
        console.log(moment().subtract(1, 'months').toDate().getTime(),
            moment().toDate().getTime())
        console.log(this.state.options.xaxis/*, this.state.options.xaxis.categories[0],
    this.state.options.xaxis.categories[10]*/)
        switch (timeline) {
            case 'one_month':
                ApexCharts.exec(
                    'area-datetime',
                    'zoomX',
                    this.state.options.xaxis.categories[0],
                    this.state.options.xaxis.categories[10]
                )

                break
            case 'six_months':
                ApexCharts.exec(
                    'area-datetime',
                    'zoomX',
                    moment().subtract(6, 'months').toDate().getTime(),
                    new Date().getTime()
                )
                break
            case 'one_year':
                ApexCharts.exec(
                    'area-datetime',
                    'zoomX',
                    moment().subtract(1, 'years').toDate().getTime(),
                    new Date().getTime()
                )
                break
            case 'ytd':
                ApexCharts.exec(
                    'area-datetime',
                    'zoomX',
                    moment().startOf('year').toDate().getTime(),
                    new Date().getTime()
                )
                break
            case 'all':
                ApexCharts.exec(
                    'area-datetime',
                    'zoomX',
                    new Date(this.state.options.xaxis.categories[0]).getTime(),
                    new Date().getTime()
                )
                break
            default:
        }
    }


    render() {
        return (
            <ExPaper>
                <ReactApexChart
                    options={this.state.options}
                    series={this.state.series}
                    width={'100%'}
                    height={'450px'}
                    align="center"
                    type='area'
                />
            </ExPaper>

        )
    }
}

export default AreaChart;
